// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedUserCard-cls1_7W4","cls2":"SuggestedUserCard-cls2_lxL SuggestedUserCard-cls1_7W4"};